import styled from '@emotion/styled';

import Icon from 'components/global/Icon';

export const Container = styled.div``;

export const ConfirmationDialogContainer = styled.div`
	width: 30rem;
	padding: var(--padding-1);
	box-shadow: var(--container-box-shadow);
	background: var(--modal-bg-3);
	border-radius: var(--small-border-radius);
`;

export const TopContainer = styled.div`
	display: flex;
	padding: var(--padding-2);
`;

export const ButtonContainer = styled.div`
	display: flex;
	place-content: center;
	margin: 0 0 var(--margin-2) 0;
	gap: 1rem;

	> div {
		display: flex;
		justify-content: center;
		width: 100%;

		> button {
			width: 75%;
			margin: 0 var(--margin-2);
		}
	}
`;

export const ContentCol = styled.div``;

export const Heading = styled.div`
	font-weight: bold;
	font-size: var(--paragraph3-font-size);
	margin-bottom: var(--margin-1);
	color: var(--black);
`;

export const Body = styled.div`
	font-size: var(--paragraph3-font-size);
	color: var(--content-4);
`;

export const IconStyled = styled(Icon)`
	margin: var(--margin-1) var(--margin-2) 0 0;
	color: var(--black);

	body[dir='rtl'] & {
		margin: var(--margin-1) 0 0 var(--margin-2);
	}
`;
